/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Track_Labels_Compare_Track_Aria_LabelInputs */

const en_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Track`)
};

const fr_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste de comparaison`)
};

const de_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichsstrecke`)
};

const it_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta traccia`)
};

const ru_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнить трек`)
};

const es_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar pista`)
};

const zh_cn2_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较轨道`)
};

const ja_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックを比較`)
};

const hi_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक की तुलना करें`)
};

const pt_pt2_track_labels_compare_track_aria_label = /** @type {(inputs: Track_Labels_Compare_Track_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar faixa`)
};

/**
* | output |
* | --- |
* | "Compare Track" |
*
* @param {Track_Labels_Compare_Track_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const track_labels_compare_track_aria_label = /** @type {((inputs?: Track_Labels_Compare_Track_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Track_Labels_Compare_Track_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_track_labels_compare_track_aria_label(inputs)
	if (locale === "de") return de_track_labels_compare_track_aria_label(inputs)
	if (locale === "it") return it_track_labels_compare_track_aria_label(inputs)
	if (locale === "ru") return ru_track_labels_compare_track_aria_label(inputs)
	if (locale === "es") return es_track_labels_compare_track_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_track_labels_compare_track_aria_label(inputs)
	if (locale === "ja") return ja_track_labels_compare_track_aria_label(inputs)
	if (locale === "hi") return hi_track_labels_compare_track_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_track_labels_compare_track_aria_label(inputs)
	return en_track_labels_compare_track_aria_label(inputs)
});